import { LuCake, LuHeart } from 'react-icons/lu';
import { IoIosHeartEmpty } from 'react-icons/io';
import { LuUsers } from 'react-icons/lu';
import { PiGraduationCap } from 'react-icons/pi';
import { PiForkKnife } from 'react-icons/pi';

const BookingData = [
  {
    title: 'Birthday',
    icon: <LuCake />,
  },
  {
    title: 'Anniversary',
    icon: <IoIosHeartEmpty />,
  },
  {
    title: 'Business',
    icon: <LuCake />,
  },
  {
    title: 'Date Night',
    icon: <LuUsers />,
  },

  {
    title: 'First Date',
    icon: <LuHeart />,
  },
  {
    title: 'Graduation',
    icon: <PiGraduationCap />,
  },

  {
    title: 'Casual Dining',
    icon: <PiForkKnife />,
  },
];

export default BookingData;
